/* global THREE */
import aframe from "aframe";
import { bindEventPlayPause } from "aframe-event-decorators";

let poolEl;

aframe.registerComponent("explosion", {
  // Dependencies must be explicit. Does not support generic multi component name only.
  //    Ex. dependencies: ["pool"] will only match to a component called 'pool'.
  dependencies: ["misound", "misound__weak", "misound__heavy"],
  schema: {
    color: { type: "color", default: "red" },
    growTime: { type: "number", default: 1.5 },
    fadeTime: { type: "number", default: 1.5 },
    size: { type: "number", default: 1 },
    audioClip: { default: "" }
  },
  init: function() {
    this.maxSize = this.el.object3D.scale.x;
    this.el.object3D.scale.set(0.01, 0.01, 0.01);
    this.timer = 0;
    this.burstColour = new THREE.Color();
    this.burstColourTimer = 0;
    if (poolEl === undefined) {
      poolEl = document.querySelector("[mipool__explosion]");
    }
    randomiseColour(this.burstColour);
  },
  reset: function() {
    this.el.object3D.scale.set(0.01, 0.01, 0.01);
    this.timer = 0;
    this.el.components[this.currentSound].setVolume(this.maxVolume);
    this.soundStarted = false;
  },
  update: function(oldData) {
    if (this.data.audioClip !== oldData.audioClip) {
      if (oldData.audioClip !== undefined) {
        const oldSound = `misound${oldData.audioClip}`;
        this.el.components[oldSound].setVolume(this.maxVolume);
      }
      this.currentSound = `misound${this.data.audioClip}`;
      this.maxVolume = this.el.components[this.currentSound].getVolume();
    }
  },
  tick: function(t, dtm) {
    const dt = dtm / 1000;

    if (!this.soundStarted) {
      this.el.components[this.currentSound].playSound();
      this.soundStarted = true;
    }

    this.burstColourTimer += dt;
    if (this.burstColourTimer > 0.05) {
      this.burstColourTimer = 0;
      randomiseColour(this.burstColour);
    }

    this.timer += dt;
    if (this.timer < this.data.growTime) {
      const size =
        this.timer / this.data.growTime * this.maxSize * this.data.size;
      this.el.object3D.scale.set(size, size, size);
      this.el.setAttribute("explosion-shader", {
        fade: 0,
        color: `#${this.burstColour.getHexString()}`
      });
    } else if (this.timer - this.data.growTime < this.data.fadeTime) {
      const fade = (this.timer - this.data.growTime) / this.data.fadeTime;
      this.el.object3D.scale.set(
        this.maxSize * this.data.size,
        this.maxSize * this.data.size,
        this.maxSize * this.data.size
      );
      this.el.setAttribute("explosion-shader", {
        fade: fade,
        color: `#${this.burstColour.getHexString()}`
      });
      this.el.components[this.currentSound].setVolume(this.maxVolume - fade * this.maxVolume);
    } else {
      this.el.components[this.currentSound].stopSound(); // Sound may still be playing
      poolEl.components.mipool__explosion.returnEntity(this.el);
    }
  },
  gamestatechanged: bindEventPlayPause({ target: "[game-state]" }, function(
    evt
  ) {
    const newState = evt.detail;
    if (newState !== "Playing") {
      poolEl.components.mipool__explosion.returnEntity(this.el);
    }
  })
});

function randomiseColour(c) {
  c.setHSL(Math.random(), 1, Math.random() > 0.6 ? 1 : 0.5);
}
